import React, { Component } from "react";
import { DragDropContext } from "react-dnd";
import TouchBackend from "react-dnd-touch-backend";
import { Grid, Button, Icon } from "semantic-ui-react";
import RoomsDropTarget from "./RoomsDropTarget";
import RoomDragPreview from "./RoomDragPreview";

class RoomDragDrop extends Component {
  render() {
    const {
      available,
      selected,
      transfer,
      checkRoom,
      uncheckRoom,
      selectRooms,
      deselectRooms,
      selectedKeyword,
      availableKeyword,
      setSelectedKeyword,
      setAvailableKeyword,
      t
    } = this.props;
    return (
      <Grid columns="equal" stackable>
        <Grid.Column textAlign="center">
          <Button icon basic fluid onClick={() => selectRooms(transfer)}>
            <Icon name="arrow right" />
          </Button>
          <RoomsDropTarget
            header={t("cleaning:availableRoomsText")}
            rooms={available}
            moveItem={deselectRooms}
            checkRoom={checkRoom}
            uncheckRoom={uncheckRoom}
            transfer={transfer}
            keyword={availableKeyword}
            setKeyword={setAvailableKeyword}
            t={t}
          />
        </Grid.Column>
        <Grid.Column textAlign="center">
          <Button icon basic fluid onClick={() => deselectRooms(transfer)}>
            <Icon name="arrow left" />
          </Button>
          <RoomsDropTarget
            header={t("cleaning:selectedRoomsText")}
            rooms={selected}
            moveItem={selectRooms}
            checkRoom={checkRoom}
            uncheckRoom={uncheckRoom}
            transfer={transfer}
            keyword={selectedKeyword}
            setKeyword={setSelectedKeyword}
            t={t}
          />
        </Grid.Column>
        <RoomDragPreview transfer={transfer} />
      </Grid>
    );
  }
}

export default DragDropContext(TouchBackend({ enableMouseEvents: true }))(
  RoomDragDrop
);



// WEBPACK FOOTER //
// ./src/cleaning/schedule/roomPicker/components/RoomDragDrop.js